document.addEventListener('DOMContentLoaded', function () {

  function initProductSliders() {

    const isMobile = window.innerWidth <= 999;
    const sliders = document.querySelectorAll('.product-slider');

    sliders.forEach((slider) => {

      // If desktop → destroy existing swiper
      if (!isMobile) {
        if (slider.swiper) {
          slider.swiper.destroy(true, true);
        }
        return; // stop here for desktop
      }

      // If already initialized, skip
      if (slider.classList.contains('swiper-initialized')) return;

      // Initialize only on mobile
      new Swiper(slider, {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        allowTouchMove: true,

        pagination: {
          el: slider.querySelector('.swiper-pagination'),
          clickable: true
        }
      });

    });

  }

  initProductSliders();

  window.addEventListener('resize', function () {
    initProductSliders();
  });

});